<section>
  <h1>NESS User Profile Details</h1>
  <p-tabView>
    <p-tabPanel header="User Information" [selected]="true">
      <ness-userinformation></ness-userinformation>
    </p-tabPanel>
    <p-tabPanel header="User Preferences" *removeIfNoPermission="canView">
      <ness-user-preferences></ness-user-preferences>
    </p-tabPanel>
    <p-tabPanel header="App Admin/Power User List">
      <ness-administrator-list></ness-administrator-list>
    </p-tabPanel>
  </p-tabView>
</section>
